module.exports = __webpack_public_path__ + "img/create.d0fe51c1.svg";